import { createSelector } from 'reselect';

import getSubmitResult from '@r1-frontend/bp42/selectors/getSubmitResult';
import getViewDetails from '@r1-frontend/bp42/selectors/getViewDetails';
import isNeedToShowResult from '@r1-frontend/bp42/selectors/isNeedToShowResult';

const selectDataForCallbackPopup = createSelector(
    [
        isNeedToShowResult,
        getSubmitResult,
        getViewDetails,
    ], (
        needToShowResponseResult,
        result,
        viewDetails,
    ) => ({
        needToShowResponseResult,
        result,
        viewDetails,
    }),
);

export default selectDataForCallbackPopup;
